import DepartmentListConfig from './create-department/DepartmentListConfig';
import StaffTableConfig from './staff-table/StaffTableConfig';
import UsersConfig from './users/UsersConfig';

const hrConfig = [DepartmentListConfig, UsersConfig, StaffTableConfig];

export default hrConfig;
